<template>
    <div>
        <el-carousel style="height: 450px;">
            <el-carousel-item style="height: 450px;">
                <img src="../../static/img/zg1.png">
            </el-carousel-item>

            <el-carousel-item style="height: 450px;">
                <img src="../../static/img/zg2.jpg">
            </el-carousel-item>
        </el-carousel>
        <dt class="pageBT" style="padding-bottom:0px;">
            <p class="zh"><span>报名入口</span></p>
            <p class="en">Authorized Unit</p>
        </dt>
        <div class="md2018040401lty">
            <div class="container" id="containerList">
                <div class="md-com-list">
                    <div class="md-hd">
                        <ul class="md-bd clearfix md-2018040201-lty">
                            <li @click="affirm(5)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><a href="javascript:;" data-level="5" title="五级（初级工）"
                                        class=" jslevel"><img src="../../static/img/declare_five.jpg"
                                            onerror="this.onerror=null;this.src='/img/declare_five.jpg'"><i
                                            class="state"></i>
                                    </a></div>
                            </li>
                            <li @click="affirm(4)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><a href="javascript:;" data-level="4" title="四级（中级工）"
                                        class=" jslevel"><img src="../../static/img/declare_four.jpg"
                                            onerror="this.onerror=null;this.src='/img/declare_four.jpg'"><i
                                            class="state"></i>
                                    </a></div>
                            </li>
                            <li @click="affirm(3)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><a href="javascript:;" data-level="3" title="三级（高级工）"
                                        class=" jslevel"><img src="../../static/img/declare_three.jpg"
                                            onerror="this.onerror=null;this.src='/img/declare_three.jpg'"><i
                                            class="state"></i>
                                    </a></div>
                            </li>
                            <li @click="affirm(2)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><a href="javascript:;" data-level="2" title="技师"
                                        class=" jslevel"><img src="../../static/img/declare_two.jpg"
                                            onerror="this.onerror=null;this.src='/img/declare_two.jpg'"><i
                                            class="state"></i>
                                    </a></div>
                            </li>
                            <li @click="affirm(1)" data-id="2dc14ac9827d4358b159c780725cf7e0"
                                class="pic-box pic-box-g pull-left live">
                                <div class="hd-pic"><a href="javascript:;" data-level="1" title="高级技师"
                                        class=" jslevel"><img src="../../static/img/declare_one.jpg"
                                            onerror="this.onerror=null;this.src='/img/declare_one.jpg'"><i
                                            class="state"></i>
                                    </a></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'app',
        components: {
        },
        data() {
            return {

            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            //综改区报名
            affirm(data) {
                if (this.$storage.get('declareUser') != null && this.$storage.get('declareUser') != undefined) {
                    this.$router.push({ path: '/affirm1/' + data +"/2" });
                } else {
                    this.$router.push({ path: '/login' });
                }
            }
        }
    }
</script>
<style scoped>
    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1228px;
    }

    .md-com-list .md-hd {
        padding: 15px 0 15px;
        line-height: 27px;
        overflow: hidden;
    }

    .md-2018040201-lty .pic-box {
        position: relative;
        transition: all .1s ease;
        overflow: hidden;
        width: 224px;
        margin: 0 10px;
        border-radius: 5px;
        margin-bottom: 20px;
    }

    .pull-left {
        float: left;
    }

    .md-2018040201-lty .pic-box .hd-pic {
        height: 160px;
        position: relative;
    }

    .md-2018040201-lty .pic-box .hd-pic img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }

    .md-19120602-xxw .state,
    .md-2018040201-lty .pic-box .state {
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 44px;
        z-index: 2;
        display: none;
    }

    .pageBT .en {
        width: 100%;
        color: #cacaca;
        font-size: 18px;
        font-family: "impact";
        height: 20px;
    }

    .pageBT .zh span {
        background-color: #fff;
        padding: 0px 32px;
        font-size: 30px;
        position: relative;
        top: 6px;
    }

    .pageBT .zh {
        border-bottom: 1px solid #e5e5e5;
        width: 586px;
        margin: 0px auto 22px;
        height: 28px;
    }

    .pageBT {
        color: #575757;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
        zoom: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/HeddleChangeAreaHomePage.vue